import styled from 'styled-components';

export const ContainerButton = styled.div`
  margin-top: 100px;
`;
